// extracted by mini-css-extract-plugin
export var bubble = "_p-0";
export var container = "_p-f";
export var contrastBorder = "_p-g";
export var greyOut = "_p-2";
export var initialsColor0 = "_p-3";
export var initialsColor1 = "_p-4";
export var initialsColor10 = "_p-d";
export var initialsColor11 = "_p-e";
export var initialsColor2 = "_p-5";
export var initialsColor3 = "_p-6";
export var initialsColor4 = "_p-7";
export var initialsColor5 = "_p-8";
export var initialsColor6 = "_p-9";
export var initialsColor7 = "_p-a";
export var initialsColor8 = "_p-b";
export var initialsColor9 = "_p-c";
export var initialsWrapper = "_p-1";
export var large = "_p-l";
export var medium = "_p-k";
export var mediumSmall = "_p-j";
export var mediumSmallMedium = "_p-o";
export var micro = "_p-h";
export var small = "_p-i";
export var tiny = "_p-n";
export var xTiny = "_p-m";